import { render, staticRenderFns } from "./EditarPatrocinador.vue?vue&type=template&id=1edbc5fc"
import script from "./EditarPatrocinador.vue?vue&type=script&lang=js"
export * from "./EditarPatrocinador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports